<template>
  <div class="flex flex-col gap-4">
    <div class="font-bold">{{ t('uploadAttachments') }}</div>
    <div class="flex gap-2">
      <el-upload
        drag
        multiple
        v-model:file-list="files"
        list-type="picture-card"
        :auto-upload="false"
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
      >
        <template #file="{ file }">
          <div class="w-[148px]">
            <template v-if="isImage(file.name)">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
            </template>
            <template v-else>
              <div class="w-full h-full flex items-center justify-center">
                <el-icon style="font-size: 48px">
                  <Document/>
                </el-icon>
              </div>
            </template>
            <label class="absolute left-[50%] translate-x-[-50%] bottom-0 bg-black/45 text-white p-1 w-[100%] truncate">
              {{ file.name }}
            </label>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                <el-icon><Delete/></el-icon>
              </span>
            </span>
          </div>
        </template>
        <div class="m-[17px] text-xl">
          <el-icon>
            <Plus/>
          </el-icon>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, ref } from "vue";
import { Delete, Document, Plus } from '@element-plus/icons-vue'
import type { UploadUserFile } from 'element-plus'
import { useI18n } from "vue-i18n";
import { watch } from "vue-demi";

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const { t } = useI18n({
  messages: {
    en: {
      uploadAttachments: 'Upload Attachments',
    },
    ar: {
      uploadAttachments: 'رفع مرفقات',
    }
  }
})

const files = ref<Array<UploadUserFile>>([]);

watch(() => files, (newValue) => {
  // Emit raw files for FormData upload
  emit('update:modelValue', newValue.value.map(v => v.raw).filter(Boolean))
}, { deep: true })

function handleRemove(uploadFile: UploadUserFile) {
  files.value = files.value.filter(f => f.uid != uploadFile.uid)
}

function isImage(filename: string): boolean {
  if (!filename) return false;
  const ext = filename.toLowerCase().split('.').pop();
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext || '');
}
</script>

<style scoped>
</style>
